/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown> }} Apartment_Checkout_UntilInputs */

const en_apartment_checkout_until = /** @type {(inputs: Apartment_Checkout_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Check-out by ${i?.time}`)
};

/**
* | output |
* | --- |
* | "Check-out by {time}" |
*
* @param {Apartment_Checkout_UntilInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const apartment_checkout_until = /** @type {((inputs: Apartment_Checkout_UntilInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Apartment_Checkout_UntilInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_apartment_checkout_until(inputs)
});